"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      stores: {},
      areas: areas,
      loading: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    axios.get(apiUrl + '/api/get_store').then(function (response) {
      var stores = {};
      response.data.items.forEach(function (item) {
        if (item.area === undefined) return;

        if (!(item.area in stores)) {
          stores[item.area] = [];
        }

        var store = {
          name: item.name,
          postalCode: item.postal_code,
          address: item.address,
          tel: item.navidial || item.navidial_comment ? item.navidial + (item.navidial && item.navidial_comment ? '<br>' : '') + _this.nl2br(item.navidial_comment) : undefined,
          openingHour: item.opening_hour,
          img: item.pr.img[0] ? olineImgUrl + '/' + item.pr.img[0] : undefined,
          url: '/store/' + item.id + '/',
          twitterId: item.twitter_id,
          facebookId: item.facebook_id
        };
        stores[item.area].push(store);
      });
      _this.stores = stores;

      _this.$nextTick(function () {
        _this.scrollAnchor();
      });

      _this.loading = false;
    });
  }
});